import { render } from "./Court.vue?vue&type=template&id=279a02f6"
import script from "./Court.vue?vue&type=script&lang=js"
export * from "./Court.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__